<template>
  <footer>
    <!-- <div class="foot">
        <div class="foot_content">
            <div class="logal">
                <img src="../../img/footerlogo.png"  style="width:165px;height:50px;" />
            </div>
            <div class="ercode">
                <img src="../../assets/weiqr.jpg" />
            </div>
            <div class="product">
                <h3>商务合作</h3>
                <div>企业QQ：800023102</div>
                <div>咨询电话：{{config.tel}}</div>
                <div>投诉电话：021-61672866</div>
            </div>
            <div class="sep"></div>
            <div class="product" style="padding-top: 0;    margin-top: -20px;">
                <h3>产品中心</h3>
                <div class="p_center">
                    <div class="p_left">
                    <div @click="$router.push('/resource/news')">软文推广</div>
                    <div  @click="$router.push('/resource/video')">短视频</div>
                    <div @click="$router.push('/resource/woa')">微信公众号</div>
                </div>
                <div class="p_right">
                    <div  @click="$router.push('/resource/weibo')">微博</div>
                    <div  @click="$router.push('/resource/live')">网红直播</div>
                    <div  @click="$router.push('/own/personal/profile')">用户中心</div>
                </div>
                </div>


            </div>
            <div class="sep"></div>
            <div class="product">
                <h3>关于我们</h3>
                <div><a href="https://www.711.cn/about.html" style="color: #d8d9db;">企业介绍</a></div>
                <div style="margin-bottom:30px;"><a href="https://www.711.cn/agreement.html" style="color: #d8d9db;">服务协议</a></div>

            </div>


        </div>
    </div> -->


    <div class="contact">
      <!--<div>
          {{config.beian_gn}} {{config.beian}} {{config.copyright}}
      </div>-->
      <div>

        <a :href="config.site_host" target="_blank" class="link">网站首页</a>
        <template v-if="!config.agency_key">
          <a :href="config.site_host + '/about.html'" target="_blank" class="link">关于我们</a>
          <a :href="config.site_host + '/agreement.html'" target="_blank" class="link">服务协议</a>
        </template>
        <a href="javascript:void(0)" target="_blank" class="link">官方QQ：{{config.qq}}</a>
      </div>
    </div>
    <white-space/>

    <!--<div class="v" v-if="!config.agency_key">
        <a target="_blank" href="https://ss.knet.cn/verifyseal.dll?sn=e1804124201007328392zl000000&comefrom=trust">
            <img src="https://static.711.cn/assets/v3/images/footer_kxwz01_2.png">
        </a>
        <a target="_blank" href="https://credit.szfw.org/CX20180627080381580189.html">
            <img src="https://static.711.cn/assets/v3/images/footer_cxwz_2.png">
        </a>
        <a target="_blank" href="http://www.cn-ecusc.org.cn/cert/aqkx/site/?site=www.711.cn">
            <img src="https://static.711.cn/assets/v3/images/footer_qgaqkxwz_2.png">
        </a>
        <a href="https://v.pinpaibao.com.cn/cert/site/?site=www.711.cn&at=realname"
            target="_blank">
            <img src="https://static.711.cn/assets/v3/images/footer_aqlmhyrz_2.png" alt="">
        </a>
    </div>-->
    <white-space/>

  </footer>

</template>

<script>
  export default {};

</script>

<style scoped>
  footer {
    width: 1260px;
    margin: 0 auto;
    height: 40px;
    color: #b6b6b6;
    border-top: 1px solid #eeeeee;
    padding: 24px 0;
    margin-top: 62px;
    font-size: 12px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 24px;
  }

  footer a {
    color: #b6b6b6;
  }

  .contact {
    flex: 1;
    height: 40px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    text-align: center;
  }

  .contact a:not(:first-child) {
    margin-left: 24px;
  }

  .v {
    text-align: center;
  }

  .v>a {
    margin: 0 4px;
  }

  .v>a>img {
    border: 1px solid #ebeef6;
  }

</style>



// WEBPACK FOOTER //
// src/components/global/Footer.vue